import type { GridColDef } from "@mui/x-data-grid-premium";
import GridTextHoverLink from "@entrilia/shared/components/grid/GridTextHoverLink";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import type { Dashboard } from "../../../api/types/dashboardsTypes.ts";
import DashboardActions from "./components/DashboardActions";

interface Params {
  hasAccessToManageDashboards: boolean;
  getDashboardPath: (dashboardId: string) => string;
  onDelete: (dashboardId: string) => void;
  onDuplicate: (dashboardId: string) => void;
  onCopy: (dashboardIds: string[]) => void;
}

export const getColumnDefinitions = ({
  hasAccessToManageDashboards,
  getDashboardPath,
  onDelete,
  onDuplicate,
  onCopy,
}: Params): GridColDef<Dashboard>[] => {
  const actions: GridColDef<Dashboard>[] = [
    {
      field: "nameUserInput",
      headerName: "Name",
      flex: 2,
      renderCell: ({ row }) => <GridTextHoverLink to={getDashboardPath(row.dashboardId)} text={row.nameUserInput} />,
    },
    {
      field: "createdBy",
      headerName: "Created By",
      flex: 1,
    },
    {
      field: "modifiedBy",
      headerName: "Modified By",
      flex: 1,
    },
    {
      field: "modifiedAt",
      headerName: "Modified At",
      flex: 1,
      valueGetter: (_, row) => convertISODateTime(row.modifiedAt),
    },
  ];

  if (hasAccessToManageDashboards) {
    actions.push({
      field: "actions",
      sortable: false,
      resizable: false,
      headerName: "Actions",
      width: 80,
      cellClassName: "grid-row-actions",
      align: "right",
      headerAlign: "right",
      renderCell: ({ row }) => (
        <DashboardActions
          dashboardId={row.dashboardId}
          onDelete={onDelete}
          onDuplicate={onDuplicate}
          onCopy={() => onCopy([row.dashboardId])}
        />
      ),
    });
  }

  return actions;
};
